const { getOffsetTop } = window.BAO.Utils

class ProductContent extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = 0

    this.updateEl()
    this.revealConversionButton()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onScrollerClick = this.onScrollerClick.bind(this)
    this.onConvertClick = this.onConvertClick.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    if (this?.els?.scroller?.exists) {
      this.listeners.add(
        this.els.scroller.element,
        'click',
        this.onScrollerClick,
      )
    }

    if (this?.els?.convert?.exists) {
      this.els?.convert?.elements.forEach((el) => {
        this.listeners.add(el, 'click', this.onConvertClick)
      })
    }
  }

  onConvertClick (e) {
    const conversion = e.target.dataset.value

    this.els?.convert?.elements.forEach((el) => {
      el.setAttribute('aria-pressed', el.dataset.value === conversion)
    })

    this.els?.size?.elements.forEach((el) => {
      const cm = parseFloat(el?.dataset?.cm)
      const showUnits = el?.dataset?.showUnits !== 'false'

      if (conversion === 'cm') {
        el.textContent = showUnits
          ? `${cm}${window.theme.strings.cm}`
          : `${cm}`
      } else {
        if (!isNaN(cm)) {
          const inches = (cm / 2.54).toFixed(1).replace(/\.0$/, '')
          el.textContent = showUnits
            ? `${inches}${window.theme.strings.in}`
            : `${inches}`
        } else {
          el.textContent = ''
        }
      }
    })

    this.setCartAttribute('size_conversion', conversion)
  }

  revealConversionButton () {
    if (this.els?.size?.elements) {
      this.els?.conversion?.element?.removeAttribute('aria-hidden')
    }
  }

  onScrollerClick () {
    const mediaOffset = getOffsetTop(this.els.media.element)
    const mediaHeight = this.els.media.element.offsetHeight

    const mediaEndPoint = mediaOffset + mediaHeight

    window.scrollTo({
      top: mediaEndPoint,
      behavior: 'smooth',
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    const formOffset = 100

    const mediaOffset = getOffsetTop(this.els.media.element)
    const mediaHeight = this.els.media.element.offsetHeight

    const mediaEndPoint = mediaOffset + mediaHeight + formOffset

    const newShouldToggleClass =
      mediaEndPoint > this.lastKnownY + window.innerHeight

    if (this.shouldToggleClass !== newShouldToggleClass) {
      const detail = { toggle: this.shouldToggleClass }
      document.dispatchEvent(
        new CustomEvent('productContentToggle', { detail }),
      )
    }

    this.shouldToggleClass = newShouldToggleClass

    this.els.content.element.classList.toggle(
      this.dataset.class,
      newShouldToggleClass,
    )
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }
}

if (!customElements.get('product-content')) {
  customElements.define('product-content', ProductContent)
}
